import style from "../style/layout.module.css";
import Card from "../components/Card";

export default function GameBody({ gameData, startGame, result }) {
  return (
    <div className={style.select_wrap}>
      {gameData?.map((list) => (
        <div
          className={style.select_link}
          onClick={() => startGame(list, result)}
          key={list.name}
        >
          <Card img={list.image} name={list.name} />
        </div>
      ))}
    </div>
  );
}
